import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { useAuth } from './contexts/AuthContext';
import Login from './pages/auth/Login';
import StaffLogin from './pages/auth/StaffLogin';
import DashboardRouter from './pages/DashboardRouter';
import TwoFactorVerification from './pages/auth/TwoFactorVerification';
import LandingPage from './pages/public/LandingPage';
import SignupWizard from './pages/public/SignupWizard';
import PaymentSuccess from './pages/public/PaymentSuccess';
// TruckerSignup.js removed, we use unified SignupWizard
import SetPassword from './pages/auth/SetPassword';


// Protected Route Component
function ProtectedRoute({ children }) {
  const { isAuthenticated, loading } = useAuth();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50">
        <div className="text-center">
          <div className="inline-block animate-spin rounded-full h-12 w-12 border-b-2 border-orange-600"></div>
          <p className="mt-4 text-gray-600">Loading...</p>
        </div>
      </div>
    );
  }

  return isAuthenticated ? children : <Navigate to="/login" replace />;
}

function AppMain() {
  const { isAuthenticated, loading } = useAuth();
  console.log("🏗️ AppMain rendering, auth:", { isAuthenticated, loading });

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50">
        <div className="text-center">
          <div className="inline-block animate-spin rounded-full h-12 w-12 border-b-2 border-orange-600"></div>
          <p className="mt-4 text-gray-600">Loading...</p>
        </div>
      </div>
    );
  }

  return (
    <Routes>
      {/* Public Routes */}
      <Route path="/" element={<LandingPage />} />
      <Route path="/signup/meal-plans" element={<SignupWizard />} />
      <Route path="/signup/truckers" element={<SignupWizard />} />
      <Route path="/signup/success" element={<PaymentSuccess />} />
      <Route path="/create-password" element={<PaymentSuccess />} />
      <Route path="/set-password" element={<SetPassword />} />
      <Route path="/payment-success" element={<PaymentSuccess />} />


      {/* Login Route - redirect to dashboard if already logged in */}
      <Route path="/login" element={<Login />} />
      <Route path="/staff-login" element={<StaffLogin />} />

      {/* 2FA Verification Route */}
      <Route
        path="/verify-2fa"
        element={<TwoFactorVerification />}
      />

      {/* Protected Dashboard Route */}
      <Route
        path="/dashboard"
        element={
          <ProtectedRoute>
            <DashboardRouter />
          </ProtectedRoute>
        }
      />

      {/* Fallback Route */}
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

export default AppMain;
